import React from 'react';
import VisualisationsToolboxAbstract from '../VisualisationsToolboxAbstract';
import ParticipantJourneyMap from '../../components/analysis/visualisations/ParticipantJourneyMap';

class JourneymapToolbox extends VisualisationsToolboxAbstract {
  static addParams() {}

  static canProcess(nextProps) {
    return true;
  }

  static getVisualisationComponent(props) {
    if (!props.journeyMap) {
      throw new TypeError('Missing JourneyMap prop');
    }
    return props.journeyMap.map(jm => (
      <ParticipantJourneyMap key={jm.participantId} journeyMap={jm} />
    ));
  }

  static getProcessButtonLabel() {
    return 'Process the Participant Journey Map';
  }

  static getBlockParameters() {
    return {
      windowdStep: 1,
      windowdSize: 2,
      extract: true
    };
  }
}

export default JourneymapToolbox;



// WEBPACK FOOTER //
// ./src/scenes/analysis/lib/visualisationTypes/JourneymapToolbox.js